import React from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { Container } from './styles';
import { parseBlockContent } from '../../../components/PageBuilder/parseBlockContent';

interface MarkdownRendererProps {
  content: string;
  isHtml?: boolean;
}

export const HelpCenterAccordionItem: React.FC<MarkdownRendererProps> = ({
  content,
  isHtml = false
}) => {
  if (isHtml) {
    return <Container>{parseBlockContent({ html: content })}</Container>;
  }

  const rawHtml = marked.parse(content) as string;

  const sanitizedHtml = DOMPurify.sanitize(rawHtml);

  return <Container dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};
